import { Button } from "@/components/ui/button";

const PageHero = ({ 
  title, 
  subtitle, 
  primaryCTA, 
  secondaryCTA,
  onPrimaryCTA,
  onSecondaryCTA,
  children 
}) => {
  return (
    <section 
      data-testid="page-hero"
      className="pt-24 lg:pt-32 pb-12 lg:pb-16 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
        <div className="max-w-3xl">
          <h1 
            data-testid="page-hero-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-[#0F172A] leading-tight"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            {title}
          </h1>
          
          {subtitle && (
            <p 
              data-testid="page-hero-subtitle"
              className="mt-4 text-lg text-[#0F172A]/70 leading-relaxed"
            >
              {subtitle}
            </p>
          )}

          {(primaryCTA || secondaryCTA) && (
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              {primaryCTA && (
                <Button 
                  data-testid="page-hero-primary-cta"
                  onClick={onPrimaryCTA}
                  className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-6 text-base font-medium rounded-xl"
                >
                  {primaryCTA}
                </Button>
              )}
              {secondaryCTA && (
                <Button 
                  data-testid="page-hero-secondary-cta"
                  onClick={onSecondaryCTA}
                  variant="outline"
                  className="border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white px-8 py-6 text-base font-medium rounded-xl"
                >
                  {secondaryCTA}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
